module.exports = __webpack_public_path__ + "static/media/profile_24.6ed71b39.jpg";